// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ShippingForm-module-container-lrarr{color:#373a36;display:grid;grid-gap:24px;gap:24px}.ShippingForm-module-submitButtonWrapper-KzXSM.ShippingForm-module-desktop-LxK6G{display:none}@media(min-width: 960px){.ShippingForm-module-submitButtonWrapper-KzXSM.ShippingForm-module-mobile-Fcvg6{display:none}.ShippingForm-module-submitButtonWrapper-KzXSM.ShippingForm-module-desktop-LxK6G{display:block}}.ShippingForm-module-submitButton-foBO-{max-width:180px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ShippingForm-module-container-lrarr",
	"submitButtonWrapper": "ShippingForm-module-submitButtonWrapper-KzXSM",
	"desktop": "ShippingForm-module-desktop-LxK6G",
	"mobile": "ShippingForm-module-mobile-Fcvg6",
	"submitButton": "ShippingForm-module-submitButton-foBO-"
};
export default ___CSS_LOADER_EXPORT___;
